import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges
} from "@angular/core";

@Directive({
  selector: "[scrollIntoView]",
  standalone: false
})
export class ScrollIntoViewDirective implements OnChanges {
  @Input("scrollIntoView") input!: boolean;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes["input"];
    if (change && change.currentValue) {
      (<any>this.elementRef.nativeElement)["scrollIntoViewIfNeeded"]
        ? (<any>this.elementRef.nativeElement)["scrollIntoViewIfNeeded"]()
        : this.elementRef.nativeElement.scrollIntoView();
    }
  }
}
